var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 rounded w-80 h-32 bg-accent text-white fixed top-0 right-0 mt-16 mr-8 z-50 opacity-100 toast",class:! _vm.show ? 'hidden' : 'opacity-100'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }